/**
 * After paste, slot the new cards into ELK. Use the instant path so a large
 * paste cannot leave the canvas locked (animated Tidy hides edges and puts up
 * a full-screen blocker until ELK reveals — if that pass is cancelled the
 * board stays frozen: stacked cards, no connections, no click-to-deselect).
 */
function runPasteAutoLayout(flowchartRef) {
  const api = flowchartRef?.current;
  if (typeof api?.autoLayoutInstant === 'function') {
    api.autoLayoutInstant({ skipRecordAction: true });
    return;
  }
  api?.autoLayout?.(new Set(), { skipRecordAction: true });
}

export function schedulePasteAutoLayout(flowchartRef) {
  setTimeout(() => runPasteAutoLayout(flowchartRef), 50);
}

function dimensionsReady(flowchartRef, taskIds) {
  const dims = flowchartRef?.current?.getNodeDimensions?.() || {};
  return (taskIds || []).every((id) => {
    const d = dims[id];
    return d && Number.isFinite(d.width) && d.width > 0 && Number.isFinite(d.height) && d.height > 0;
  });
}

/** Wait until new cards have sizes, then tidy. Instant tidy before measure stacks them. */
export function schedulePasteAutoLayoutAfterMeasure(flowchartRef, taskIds, timeoutMs = 2000) {
  const started = Date.now();
  const tick = () => {
    const ready = taskIds?.length && dimensionsReady(flowchartRef, taskIds);
    if (ready || Date.now() - started > timeoutMs) {
      runPasteAutoLayout(flowchartRef);
      return;
    }
    setTimeout(tick, 50);
  };
  setTimeout(tick, 50);
}
